import React from 'react';
import { Card, Grid, Link, Typography, useMediaQuery } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AdvisoryCloudLogo from '../../../components/AdvisoryCloudLogo';
import { withRouter } from 'react-router';
import FormLogin from '../../../components/LoginForm/index';
import ModalResetPassword from './ModalForgotPassword';
import ModalContactSupport from './ModalContactSupport';

const useStyles = () => ({
  container: {
    display: 'flex',
    height: '100vh',
  },
  gridContainer: {
    backgroundColor: '#F9F9FC',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-center',
    marginTop: '-5vh',
  },
  loginText: {
    textAlign: 'center',
    color: 'theme.palette.secondary.dark',
    marginTop: '3vh',
  },
  linkContainer: {
    textAlign: 'center',
    marginTop: '2vh',
  },
});

function Clogin() {
  const location = useLocation();
  const [openReset, setOpenReset] = React.useState(false);
  const [openContact, setOpenContact] = React.useState(false);
  const isSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const classes = useStyles();
  const { t } = useTranslation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get('email');

  const handleReset = (value) => setOpenReset(value ?? !openReset);
  const handleContact = (value) => setOpenContact(value ?? !openContact);

  const AuxLinks = (
    <Grid item>
      <Typography variant="h3" sx={classes.linkContainer}>
        <Link
          color="primary"
          underline="always"
          variant="h3"
          style={{ cursor: 'pointer' }}
          onClick={() => handleReset(true)}
        >
          Reset your password
        </Link>
      </Typography>

      <Typography variant="h3" sx={{...classes.linkContainer, marginTop: '8px'}}>
        <Link
          color="primary"
          underline="always"
          variant="h3"
          style={{ cursor: 'pointer' }}
          onClick={() => handleContact(true)}
        >
         Need help? Contact us!
        </Link>
      </Typography>
    </Grid>
  );

  return (
    <div style={{ ...classes.container, marginTop: isSM ? '-15px' : 0 }}>
      <Grid container spacing={0} justify="center" sx={classes.gridContainer}>
        <Card
          sx={{
            maxWidth: isSM ? '80%' : '300px',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Grid container justify="center" direction="column">
            <Grid item>
              <AdvisoryCloudLogo width="100%" />
            </Grid>
            <Grid item>
              <Typography variant="h3" sx={classes.loginText}>
                {t('LOGIN_TEXT')}
              </Typography>
              <ModalResetPassword
                prePopulatedEmail={email}
                open={openReset}
                onChange={handleReset}
              />
              <ModalContactSupport open={openContact} onChange={handleContact} />
            </Grid>
            <Grid item>
              <FormLogin LostPasswordComponent={AuxLinks} />
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </div>
  );
}

export default withRouter(Clogin);
